
    <button mat-icon-button [matMenuTriggerFor]="menuOptions"
            class="se-header-toolbar-button"
            [matTooltip]="getOptionsTranslation()">
        <mat-icon>build</mat-icon>
    </button>

    <mat-menu #menuOptions="matMenu" yPosition="below" xPosition="before" color='primay' class="se-mat-menu">
        <button mat-menu-item [matMenuTriggerFor]="themes" class="se-header-toolbar-item-info"> <span translate>Themes</span></button>
    </mat-menu>
    <mat-menu #themes="matMenu" class="se-mat-menu">
        <button mat-menu-item (click)="onChangeThemeLight()" class="se-header-toolbar-item-info se-menu-button">
            <mat-icon>wb_sunny</mat-icon>
            <span translate>LightTheme</span>
        </button>
        <button mat-menu-item (click)="onChangeThemeDark()" class="se-header-toolbar-item-info se-menu-button">
            <mat-icon>brightness_3</mat-icon>
            <span translate>DarkTheme</span>
        </button>
    </mat-menu>



